import { cn } from "@/lib/utils";
import { ProgressActivity } from "@/components/common/Icons/Icons";

const Spinner = ({ className }) => {
  return (
    <ProgressActivity
      className={cn("[fill:currentColor] w-4 h-4 animate-spin", className)}
    />
  );
};

export default Spinner;
